import { Plus } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/Common/button';
import TemplatesSection from '../../components/Templates/TemplatesSection';

const TemplatesPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6 p-4 md:p-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0">
        <h1 className="text-2xl font-bold text-foreground">{t('templates.pageTitle')}</h1>
        <Button asChild>
          <Link to="/templates/new">
            <Plus className="h-4 w-4 mr-2" />
            {t('templatesSection.newTemplate')}
          </Link>
        </Button>
      </div>

      <TemplatesSection showCreateButton={false} />
    </div>
  );
};

export default TemplatesPage;
